import React, { Component } from 'react'

import './countspecifier.scss'
import { translation } from '../../../utils/helpers'

// Elements
import Inline from '../../elements/inline'
import RemoveButton from '../../elements/removeButton'
import AddButton from '../../elements/addButton'

class CountSpecifier extends Component {
  constructor (props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick (type) {
    let newCount = this.props.value

    if (type === 'add') {
      newCount += 1
    } else {
      newCount -= 1
    }

    if (this.props.onChange !== null) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: newCount
        }
      })
    }
  }

  renderCount () {
    const { value, total, disabled } = this.props
    let className = 'element-count-specifier__count'
    if (disabled) className += ' disabled'

    if (!total || total < 2) {
      return (
        <div className={className}>
          {value}
        </div>
      )
    }

    return (
      <div className={className}>
        {`${value} ${translation(16436)} ${total}`}
      </div>
    )
  }

  render () {
    const { value, total, disabled } = this.props

    return (
      <div className='element-count-specifier'>
        <Inline>
          <RemoveButton
            onClick={() => this.onClick('remove')}
            disabled={value === 1 || disabled}
            size='m'
            style='link'
            dimmed={false}
            round
            minus
          />

          {this.renderCount()}

          <AddButton
            onClick={() => this.onClick('add')}
            disabled={value === total || disabled}
            size='m'
            round
          />
        </Inline>
      </div>
    )
  }
}

CountSpecifier.defaultProps = {
  onChange: null,
  disabled: false
}

export default CountSpecifier



// WEBPACK FOOTER //
// ./src/app/shared/elements/countSpecifier/index.js